import { Row } from "@tanstack/react-table";
import { SongMenuOptions } from "@/app/components/song/menu-options";
import { TableActionButton } from "@/app/components/table/action-button";
import { CachedIndicator } from "@/app/components/table/cached-indicator";
import { TableLikeButton } from "@/app/components/table/like-button";
import { useHasHover } from "@/app/hooks/use-input-mode";
import { ISong } from "@/types/responses/song";

interface SongTableActionsProps {
  row: Row<ISong>;
}

export function SongTableActions({ row }: SongTableActionsProps) {
  const hasHover = useHasHover();

  return (
    <div
      className="flex gap-1 items-center"
      onClick={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
      onTouchMove={(e) => e.stopPropagation()}
      onTouchEnd={(e) => e.stopPropagation()}
    >
      <TableActionButton
        optionsMenuItems={
          <SongMenuOptions
            variant="dropdown"
            song={row.original}
            index={row.index}
            showLikeOption={!hasHover}
          />
        }
      />
      <CachedIndicator songId={row.original.id} />
      {hasHover && (
        <>
          <TableLikeButton
            type="song"
            entityId={row.original.id}
            starred={typeof row.original.starred === "string"}
            albumId={row.original.albumId}
            song={row.original}
          />
        </>
      )}
    </div>
  );
}
